import { useTranslation } from 'react-i18next';

import { Button, Input, Select } from '@arco-design/web-react';

import useGpuTypes from '@/hooks/useGpuTypes';

interface PhysicalNodeFiltersProps {
  disabled: boolean;
  archTypes: string[];
  queryObj: Record<string, unknown>;
  onArchChange: (value: string) => void;
  onCpuChange: (value: string) => void;
  onMemoryChange: (value: string) => void;
  onGpuChange: (value: string) => void;
  onNameSearch: (value: string) => void;
  onRefresh: () => void;
}

/** 非计价模式：架构/CPU/内存/GPU/节点名筛选栏 */
export function PhysicalNodeFilters({
  disabled,
  archTypes,
  queryObj,
  onArchChange,
  onCpuChange,
  onMemoryChange,
  onGpuChange,
  onNameSearch,
  onRefresh,
}: PhysicalNodeFiltersProps) {
  const { t } = useTranslation();
  const { gpuOptions } = useGpuTypes('BMS');

  return (
    <div style={{ display: 'flex', gap: 10, marginBottom: 5 }}>
      <Select showSearch placeholder={t('common:architecture')} allowClear disabled={disabled} onChange={onArchChange}>
        {archTypes.map((item) => (
          <Select.Option key={item} value={item} />
        ))}
      </Select>
      <Select showSearch placeholder="cpu" allowClear disabled={disabled} onChange={onCpuChange}>
        {(queryObj.cpu as string[] | undefined)?.map((item) => (
          <Select.Option key={item} value={item}>
            {item}
            {t('common:cores')}
          </Select.Option>
        ))}
      </Select>
      <Select showSearch placeholder={t('common:memory')} allowClear disabled={disabled} onChange={onMemoryChange}>
        {(queryObj.memory as string[] | undefined)?.map((item) => (
          <Select.Option key={item} value={item}>
            {item}Gi
          </Select.Option>
        ))}
      </Select>
      <Select
        showSearch
        placeholder="GPU"
        allowClear
        disabled={disabled}
        onChange={onGpuChange}
        options={gpuOptions?.map((item: { label?: string }) => ({
          label: item?.label,
          value: item?.label,
        }))}
        triggerProps={{
          autoAlignPopupWidth: false,
          autoAlignPopupMinWidth: true,
          position: 'bl',
        }}
      />
      <Input
        placeholder={t('common:node.name')}
        disabled={disabled}
        onPressEnter={(event) => onNameSearch((event.target as HTMLInputElement).value || '')}
      />
      <Button type="primary" disabled={disabled} onClick={onRefresh}>
        {t('common:search')}
      </Button>
    </div>
  );
}
